import _ from 'lodash';

const reorder = (items, source, destination) => {
  const newItems = Array.from(items);
  const [reorderedItem] = newItems.splice(source, 1);
  newItems.splice(destination, 0, reorderedItem);
  return newItems;
};

const useDragAndDrop = ({ formData, setFormData, setUnchanged }) => {
  const onDragEnd = result => {
    const { type } = result;

    if (!result?.destination) return;

    const source = result.source.index;
    const destination = result.destination.index;

    if (type === 'Questions') {
      const formDataCopy = _.cloneDeep(formData);
      const newQuestions = reorder(formDataCopy.questions, source, destination);
      // eslint-disable-next-line
      const orderedQuestions = newQuestions.map((question, index) => {
        return { ...question, order: index + 1 };
      });
      formDataCopy.questions = orderedQuestions;
      setFormData(formDataCopy);
      setUnchanged(false);
      return;
    }

    const formDataCopy = _.cloneDeep(formData);
    const questionsCopy = _.cloneDeep(formDataCopy.questions);
    const answersCopy = _.cloneDeep(formDataCopy.questions[type].answers);
    const answers = reorder(answersCopy, source, destination);
    // eslint-disable-next-line
    const orderedAnswers = answers.map((answer, index) => {
      return { ...answer, order: index + 1 };
    });

    questionsCopy[type].answers = orderedAnswers;
    formDataCopy.questions = questionsCopy;
    setFormData(formDataCopy);
    setUnchanged(false);
  };
  return { onDragEnd };
};

export default useDragAndDrop;
